module.exports = __webpack_public_path__ + "img/skeleton.35a82d06.svg";